




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { MPListings } from '@/MPListings'
import { AdvancedSearch } from '@/Moment' 
import { MomentMPListing, sortOrderTypes } from '@/MomentMPListing'
import * as utils from '@/utils';
import * as utils_topshot from '@/utils_topshot';
import MomentMPListingListComponent from '@/components/MomentMPListingListComponent.vue';                               // @ is an alias to /src
import MomentSelectorAndSorterComponent from '@/components/MomentSelectorAndSorterComponent.vue';                       // @ is an alias to /src
import { IPaginationResult } from '@/PaginationResult'
import { Challenge } from '@/Challenge'

@Component({
  name: 'MPListingsComponent',
  components: { MomentMPListingListComponent, MomentSelectorAndSorterComponent }
})
export default class MPListingsComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public startingPlayerID: number
  @Prop()
  public startingSetID: number
  @Prop()
  public startingPlayID: number
  @Prop()
  public startingSubeditionID: number

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentMPListing[] = []
  public mpListings: MPListings = null
  public paginationResult: IPaginationResult = null
  public sortOrder: sortOrderTypes = this.getSortOrders()[0].sort
  public showAdvanced: boolean = false
  public advancedSearchStringUsed: string = null
  public noSelector: boolean = false

  public async onChangedAdvanced(advancedSearch: AdvancedSearch) {
    if (advancedSearch) this.advancedSearchStringUsed = JSON.stringify(advancedSearch)
    else this.advancedSearchStringUsed = null

    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  // don't show owned column if we are showing moments
  // also, don't show if user did an advanced search on special serial which is confusing to show owned
  public showOwned(): boolean { 
    if (!this.showingEditions()) return false
    if (!this.advancedSearchStringUsed) return true
    if (this.advancedSearchStringUsed.includes('Serial')) return false
    if (this.advancedSearchStringUsed.includes('jersey')) return false
    if (this.advancedSearchStringUsed.includes('lastMint')) return false
    if (this.advancedSearchStringUsed.includes('neverSold')) return false
    return true
  }
  public showingEditions(): boolean { return !this.setID || !this.playID }

    // events from MomentSelectorAndSorterComponent
  public async onChangedSort(sortOrder: { label: string, sort: sortOrderTypes }) {
    this.sortOrder = sortOrder.sort
    utils_topshot.setPreferredMPSort(this.sortOrder)
    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  // TODO: handle subeditionID
  public async onChangedPSD(player: { label: string, playerID: number }, set: { label: string, setID: number }, duo: { label: string, setID: number, playID: number }) {
    this.playerID = player.playerID
    this.setID = duo.setID || set.setID

    if (!this.playID && duo.playID) {
      this.playID = duo.playID
      this.saveBreadcrumb()
    } else {
       this.playID = duo.playID
    }

    this.pageNumberToLoadNext = 1
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  // events from MomentMPListingListComponent
  public async onDrill(moment: MomentMPListing) {
    this.saveBreadcrumb()
    if (this.$store.state.devmode) console.log(`onDrill() ${this.playID} previous: ${this.previousPlayerID}/${this.previousSetID}/${this.previousPlayID}`)

    const promises: Array<Promise<any>> = []

    this.playerID = moment.playerID
    this.setID = moment.setID
    this.playID = moment.playID
    this.subeditionID = moment.subeditionID

    if (this.$store.state.devmode) console.log(`onDrill() ${this.playID} now: ${this.playerID}/${this.setID}/${this.playID}`)

    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))
    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSetIDFromParent(0))
    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(this.playerID, this.setID, this.playID))

    this.pageNumberToLoadNext = 1
    promises.push(this.fetchData(false, this.pageNumberToLoadNext))

    await Promise.all(promises)

  }

  public saveBreadcrumb() {
    this.previousPlayerID = this.playerID
    this.previousSetID = this.setID
    this.previousPlayID = this.playID
    this.previousSubeditionID = this.subeditionID
  }

  public async unDrill() {
    const promises: Array<Promise<any>> = []

    if (this.$store.state.devmode) console.log(`unDrill() ${this.playID} previous: ${this.previousPlayerID}/${this.previousSetID}/${this.previousPlayID}`)

    this.playerID = this.previousPlayerID
    this.setID = this.previousSetID
    this.playID = this.previousPlayID
    this.subeditionID = this.previousSubeditionID
    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))
    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSetIDFromParent(this.setID))
    promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(this.playerID, 0, 0))

    this.pageNumberToLoadNext = 1
    promises.push(this.fetchData(false, this.pageNumberToLoadNext))

    this.previousPlayerID = null
    this.previousSetID = null
    this.previousPlayID = null
    this.previousSubeditionID = null

    await Promise.all(promises)

    if (this.$store.state.devmode) console.log(`unDrill() ${this.playID} now: ${this.playerID}/${this.setID}/${this.playID}`)

  }

  public showUndrill(): boolean {
    if (this.$store.state.devmode) console.log(`showUndrill() ${this.setID}/${this.playID} previous: ${this.previousPlayerID}/${this.previousSetID}/${this.previousPlayID}`)
    if (!this.playID) return false
    if (!this.setID) return false
    return true
    if (this.previousPlayerID) return true
    if (this.previousSetID) return true
    if (this.previousPlayID) return true
    return false
  }

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  public getSortOrders(): Array<{ label: string, sort: sortOrderTypes }> {
    return [
      { label: 'Sort by Lowest Ask', sort: 'ListedPrice_ASC' },
      { label: 'Sort by Newest', sort: 'ListedDate_DESC' },
      { label: 'Sort by Best Deal', sort: 'Discount_DESC' },
      { label: 'Sort by Serial', sort: 'Serial_ASC' },
      { label: 'Sort by 24h Gains', sort: 'Movement_DESC' },
      { label: 'Sort by 24h Losses', sort: 'Movement_ASC' },
    ]
  }

  public isValidSortOrder(sort: sortOrderTypes): boolean {
    for (const so of this.getSortOrders()) if (so.sort === sort) return true
    return false
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private playerID: number = null
  private setID: number = null
  private playID: number = null
  private subeditionID: number = null
  private previousPlayerID: number = null
  private previousSetID: number = null
  private previousPlayID: number = null
  private previousSubeditionID: number = null

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    // props
    this.playerID = this.startingPlayerID
    this.setID = this.startingSetID || null
    this.playID = this.startingPlayID || null
    this.subeditionID = this.startingSubeditionID || 0

    // use params from URL if they exists
    if (this.$route.query.noSelector) this.noSelector = true;
    if (this.$route.query.playerID) this.playerID = Number(this.$route.query.playerID)
    if (this.$route.query.setID) this.setID = Number(this.$route.query.setID);
    if (this.$route.query.playID) this.playID = Number(this.$route.query.playID);
    if (this.$route.query.subeditionID) this.subeditionID = Number(this.$route.query.subeditionID);
    if (this.$route.query.sortOrder) {
      this.sortOrder = this.$route.query.sortOrder as sortOrderTypes;
      if (this.isValidSortOrder(this.sortOrder))
        (this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSortFromParent(this.sortOrder)
      else
        this.sortOrder = this.getSortOrders()[0].sort
    } else {
      if (utils_topshot.getPreferredMPSort()) {
        this.sortOrder = utils_topshot.getPreferredMPSort();
        if (this.isValidSortOrder(this.sortOrder))
          (this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSortFromParent(this.sortOrder)
        else
          this.sortOrder = this.getSortOrders()[0].sort
        }
    }

    const promises: Array<Promise<any>> = []

    if (this.playerID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDFromParent(this.playerID))
    if (this.setID && !this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedSetIDFromParent(this.setID))
    if (this.playerID && this.setID && this.playID) promises.push((this.$refs.MomentSelectorAndSorterComponent as MomentSelectorAndSorterComponent).notifyChangedPlayerIDAndSetIDAndPlayIDFromParent(this.playerID, this.setID, this.playID))

    // TODO: subeditionID for MomentSelectorAndSorterComponent

    promises.push(this.fetchData(false, this.pageNumberToLoadNext))

    await Promise.all(promises)
  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add flowAddresses as query params to current url path
  // TODO: add sort
  private addParamsToURL() {
    let extra: string = ''
    if (this.playerID) extra += `&playerID=${encodeURIComponent(this.playerID)}`
    if (this.setID) extra += `&setID=${encodeURIComponent(this.setID)}`
    if (this.playID) extra += `&playID=${encodeURIComponent(this.playID)}`
    if (this.subeditionID) extra += `&subeditionID=${encodeURIComponent(this.subeditionID)}`
    if (this.sortOrder && this.sortOrder !== this.getSortOrders()[0].sort) extra += `&sortOrder=${encodeURIComponent(this.sortOrder)}`
    extra = extra.replace('&', '?')
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
    if (this.$store.state.devmode) console.log(`Relacing url with ${this.$route.path}${extra}`)
  }

  // the reason for pageNumberWhenCalled is for race-condition prevention
  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const header: MomentMPListing = new MomentMPListing(null)
    header.momentID = 0
    header.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/mplistings/`;
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder}`;
    if (this.playerID) url += `&playerID=${this.playerID}`
    if (this.setID) url += `&setID=${this.setID}`
    if (this.playID) url += `&playID=${this.playID}`
    if (this.subeditionID) url += `&subeditionID=${this.subeditionID}`
    if (this.advancedSearchStringUsed) url += `&advancedSearch=${encodeURIComponent(this.advancedSearchStringUsed)}`
    if (!utils_topshot.getChallenges()) url += `&sc=true`

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`MPListingsComponent.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;
    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // challenges
      if (response.data.challenges) utils_topshot.setChallenges(response.data.challenges.map((po) => new Challenge(po)))
      if (response.data.expiredChallenges) utils_topshot.setExpiredChallenges(response.data.expiredChallenges.map((po) => new Challenge(po)))

      // load up the MPListings
      if (response.data.mpListings) {
        this.mpListings = new MPListings(response.data.mpListings)

        // pagination result
        this.paginationResult = response.data.paginationResult

        // load up the moments separately from the MPListings object in case we want to do paging (might do everything inside MPListings eventually)
        let newRawItems: MomentMPListing[] = response.data.mpListings.moments
        if (newRawItems) {
          newRawItems = newRawItems.map((po) => new MomentMPListing(po));
          if (pageNumberWhenCalled === 1) this.moments = [ header ].concat(newRawItems);
          else this.moments = this.moments.concat(newRawItems)

          this.pageNumberToLoadNext++
          this.lastFetchSucceeded = true

          this.addParamsToURL()     // shouldn't have to do this again but for some reason I do

          return newRawItems.length
        } else {
          this.lastFetchSucceeded = false;
          return 0
        }
      } else {
        this.mpListings = null
        this.paginationResult = null
        this.moments = []
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    if (this.$store.state.devmode) utils.toast(this, 'DEBUGGING', `Loaded ${this.moments.length} moments`)
  }
}
